function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".esidrex-cls-1{fill:#e2b2ae;}.esidrex-cls-2{fill:#d58c87;}.esidrex-cls-3{fill:#f7c3bd;}.esidrex-cls-4{fill:#c86867;}.esidrex-cls-5{fill:#bd2732;}.esidrex-cls-6{fill:#ba3f48;}.esidrex-cls-7{fill:#f0d8d4;}.esidrex-cls-8{fill:#e1c1c1;}.esidrex-cls-9{fill:#fbe3df;}.esidrex-cls-10{fill:#e20613;}.esidrex-cls-11{fill:#a91210;}.esidrex-cls-12{fill:#0a070f;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Calque_2",
  "data-name": "Calque 2"
}, React.createElement("g", {
  id: "Contenu"
}, React.createElement("polygon", {
  className: "esidrex-cls-1",
  points: "264.41 6.21 276.29 0.96 276.29 0.96 283.44 18.6 264.41 6.21"
}), React.createElement("polygon", {
  className: "esidrex-cls-2",
  points: "276.29 0.96 287.92 6.05 283.44 18.6 276.29 0.96"
}), React.createElement("polygon", {
  className: "esidrex-cls-3",
  points: "283.44 18.6 287.92 6.05 290.53 20.79 283.44 18.6"
}), React.createElement("polygon", {
  className: "esidrex-cls-4",
  points: "288.68 34.54 293.81 26.47 295.47 38.02 288.68 34.54"
}), React.createElement("polygon", {
  className: "esidrex-cls-5",
  points: "280.48 38.04 288.68 34.54 288.04 42.78 280.48 38.04"
}), React.createElement("polygon", {
  className: "esidrex-cls-6",
  points: "276.9 35 288.68 34.54 280.48 38.04 276.9 35"
}), React.createElement("polygon", {
  className: "esidrex-cls-5",
  points: "290.53 20.79 293.81 26.47 281.79 29.52 290.53 20.79"
}), React.createElement("polygon", {
  className: "esidrex-cls-7",
  points: "299.59 1.03 301.38 16.57 290.53 20.79 299.59 1.03"
}), React.createElement("polygon", {
  className: "esidrex-cls-1",
  points: "287.92 6.05 299.59 1.03 290.53 20.79 287.92 6.05"
}), React.createElement("polygon", {
  className: "esidrex-cls-6",
  points: "281.79 29.52 293.81 26.47 288.68 34.54 281.79 29.52"
}), React.createElement("polygon", {
  className: "esidrex-cls-3",
  points: "290.53 20.79 301.38 16.57 293.81 26.47 290.53 20.79"
}), React.createElement("polygon", {
  className: "esidrex-cls-8",
  points: "301.38 16.57 312.71 19.06 312.71 19.06 305.6 29.52 301.38 16.57"
}), React.createElement("polygon", {
  className: "esidrex-cls-1",
  points: "293.81 26.47 301.38 16.57 305.6 29.52 293.81 26.47"
}), React.createElement("polygon", {
  className: "esidrex-cls-2",
  points: "293.81 26.47 305.6 29.52 295.47 38.02 293.81 26.47"
}), React.createElement("polygon", {
  className: "esidrex-cls-9",
  points: "299.59 1.03 311.52 6.28 301.38 16.57 299.59 1.03"
}), React.createElement("polygon", {
  className: "esidrex-cls-3",
  points: "301.38 16.57 311.52 6.27 312.71 19.06 301.38 16.57"
}), React.createElement("polygon", {
  className: "esidrex-cls-6",
  points: "288.68 34.54 295.47 38.03 288.04 42.78 288.68 34.54"
}), React.createElement("polygon", {
  className: "esidrex-cls-5",
  points: "270.36 29.52 281.79 29.52 276.9 35 270.36 29.52"
}), React.createElement("polygon", {
  className: "esidrex-cls-10",
  points: "281.79 29.52 288.68 34.54 276.9 35 281.79 29.52"
}), React.createElement("polygon", {
  className: "esidrex-cls-4",
  points: "283.44 18.6 290.53 20.79 281.79 29.52 283.44 18.6"
}), React.createElement("polygon", {
  className: "esidrex-cls-11",
  points: "263.23 19.06 283.44 18.6 270.36 29.52 263.23 19.06"
}), React.createElement("polygon", {
  className: "esidrex-cls-10",
  points: "283.44 18.6 281.79 29.52 270.36 29.52 283.44 18.6"
}), React.createElement("polygon", {
  className: "esidrex-cls-5",
  points: "264.41 6.21 283.44 18.6 263.23 19.06 264.41 6.21"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M24.1,0a.59.59,0,0,1,.67.62V2.79a.6.6,0,0,1-.67.67H4v14.8H22.24c.47,0,.67.21.67.62v2.17c0,.46-.2.67-.67.67H4V35.13H24.1a.59.59,0,0,1,.67.62v2.16a.6.6,0,0,1-.67.68H.78A.69.69,0,0,1,0,37.81V.77A.68.68,0,0,1,.78,0Z"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M45.71,10.78a.64.64,0,0,1,.62.67v1.6a.58.58,0,0,1-.67.67H36.27c-2.32,0-4.49.72-4.49,3.1v.82c0,1.76.67,3.05,3.46,4.18l7.27,2.94c4.49,1.81,4.9,4.23,4.9,6.91v.62c0,5.47-3,6.55-10.11,6.55-3.71,0-8.15-.31-9-.41-.52,0-.62-.31-.62-.62v-1.6c0-.46.2-.67.62-.67h9.08c4.79,0,6.29-.62,6.29-3.25v-.67c0-1.7-.62-2.84-3.09-3.87l-7.74-3.09c-3.92-1.6-4.8-4.28-4.8-7.07V16.46c0-5.58,5.11-6,9.65-6a76,76,0,0,1,8,.36"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M54.63,10.68a.62.62,0,0,1,.67.67V37.91a.6.6,0,0,1-.67.68H52.21c-.47,0-.67-.21-.67-.68V11.35a.6.6,0,0,1,.67-.67Zm1.19-7.89a2.18,2.18,0,0,1-2.37,2.47A2.23,2.23,0,0,1,51,2.79,2.19,2.19,0,0,1,53.45.41a2.13,2.13,0,0,1,2.37,2.38"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M70,13.72c-7.12,0-7.94,2.12-7.94,10.83s.82,11,7.58,11A57.64,57.64,0,0,0,77.07,35V13.72ZM80.12,0a.6.6,0,0,1,.67.67V37.24c0,.52-.21.73-.73.78a58.42,58.42,0,0,1-10.47.82c-9.54,0-11.35-2.78-11.35-14.23S60.05,10.42,70,10.42a65.78,65.78,0,0,1,7.12.31V.67A.59.59,0,0,1,77.69,0Z"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M97.34,10.88c.42.16.62.31.62.73V13.1c0,.47-.26.67-.67.62H92.8c-3,0-4.54.47-4.54,2.94V37.91c0,.47-.2.68-.67.68H85.17a.6.6,0,0,1-.67-.68v-22c0-5.42,5.21-5.47,7.48-5.47a29.18,29.18,0,0,1,5.36.46"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M102.91,23.11h14.7c-.1-7.63-1.29-9.39-7.22-9.39-6.24,0-7.38,1.86-7.48,9.39m18.47.57v1.49c0,.88-.16,1.29-1.6,1.29H102.91c.16,7.17,1.45,9.08,7.48,9.08h8.1a.6.6,0,0,1,.67.67v1.6a.64.64,0,0,1-.62.67c-2.42.26-5.52.36-8.15.36-9.33,0-11.24-2.83-11.24-14.23s1.91-14.19,11.24-14.19c8.82,0,10.89,2.63,11,13.26"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M144.23,10.68c.51,0,.62.36.31.82l-8.82,12.28,10.06,14c.25.41.1.78-.36.78h-3a.75.75,0,0,1-.67-.42l-8.2-11.4-8.15,11.4a.75.75,0,0,1-.67.42h-3.05c-.46,0-.61-.37-.36-.78l10.06-14L122.51,11.5c-.31-.46-.2-.82.31-.82h3a.9.9,0,0,1,.73.41l6.91,9.7,7-9.7a.83.83,0,0,1,.73-.41Z"
}), React.createElement("path", {
  className: "esidrex-cls-10",
  d: "M175.62,16.11v3c0,2.61-.31,4.77-3.6,6.7l-7.75,4.46c-1.67.87-2.16,1.63-2.16,3v1h13.51c.22,0,.26,0,.26.23v3.82c0,.19-.08.23-.23.23H157c-.8,0-1-.42-1-1.06V34.16c0-3.18,1.25-4.73,4.81-6.89l8.55-5.14c1.21-.76,1.43-1.85,1.43-3.48V16.83c0-2.68-2.26-3.14-5.78-3.14h-7.23c-.26,0-.34-.07-.34-.34V10.63c0-.38.15-.49.49-.61a44.5,44.5,0,0,1,7.42-.56c5.41,0,10.29.75,10.29,6.65"
}), React.createElement("path", {
  className: "esidrex-cls-10",
  d: "M197.14,9.65c.38,0,.6.18.6.56v3.1a.53.53,0,0,1-.6.57H183.82L183.29,21c1.25-.11,2.8-.19,3.67-.19,8.06,0,11.24,1.55,11.28,8.1v1.81c0,6.47-3.26,8-11.66,8a69.71,69.71,0,0,1-7.22-.35c-.45-.11-.68-.3-.68-.68V35c0-.3.19-.41.57-.41h7.37c5.49,0,6.77-1,6.77-4.5v-.31c0-3.52-1.24-4.65-6.77-4.65h-7.15c-.56,0-.79-.19-.79-.57v-3l.79-11.35a.5.5,0,0,1,.57-.56Z"
}), React.createElement("path", {
  className: "esidrex-cls-10",
  d: "M229.82,25.84,229.74,38c0,.38-.15.57-.52.57h-3.45c-.38,0-.53-.19-.53-.57V27.27c0-5.59-.87-5.86-4.16-5.86a23.18,23.18,0,0,0-3.78.3,15.24,15.24,0,0,1,.57,4.73L217.79,38c0,.41-.15.57-.49.57h-3.48a.5.5,0,0,1-.57-.57V26.52c0-4.88-.94-5.07-4.16-5.07h-3.22V38a.5.5,0,0,1-.56.57h-3.44c-.38,0-.53-.19-.57-.57V18.69c0-.46.19-.53.57-.61a38.83,38.83,0,0,1,6.73-.6,17,17,0,0,1,6.51,1.13,20.89,20.89,0,0,1,6.35-1.17c6.24,0,8.4,1.25,8.36,8.4"
}), React.createElement("path", {
  className: "esidrex-cls-10",
  d: "M241.92,21.45c-4.16,0-4.57,1.47-4.57,6.66,0,5.41.56,6.65,4.8,6.65a30.54,30.54,0,0,0,4.12-.22V21.45Zm8.21-3.29a.7.7,0,0,1,.72.75V37.37c0,6.59-1.32,9-9,9a43.3,43.3,0,0,1-6.21-.42.57.57,0,0,1-.53-.6V43.09c0-.42.19-.57.57-.57h5.9c3.79,0,4.69-.91,4.69-3.9v-.19a28,28,0,0,1-4.84.34c-7,0-8.7-2.27-8.7-10.82,0-8.32,1.74-10.47,9.34-10.47a43.58,43.58,0,0,1,8.06.68"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M149.11,8.53v1h.43c.44,0,.57-.08.57-.46s-.13-.49-.57-.49Zm1.67.46c0,.61-.16.86-.62.95l.7,1.1s0,.06,0,.06h-.58a.12.12,0,0,1-.13-.07l-.67-1h-.34v1.07s0,0-.05,0h-.55s-.06,0-.06,0V8s0,0,.05,0c.37,0,.75,0,1.11,0,.88,0,1.17.24,1.17,1m1.37.53c0-1.81-.81-2.63-2.6-2.63s-2.6.82-2.6,2.63.81,2.62,2.6,2.62,2.6-.82,2.6-2.62m-5.66,0c0-2.12,1-3.09,3.06-3.09s3.06,1,3.06,3.09-1,3.08-3.06,3.08-3.06-1-3.06-3.08"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M6.14,43.05c.08,0,.13,0,.13.12v7.64c0,.1,0,.14-.13.14H5.6c-.1,0-.14,0-.14-.14V47.26H.81v3.55c0,.1-.05.14-.13.14H.14A.12.12,0,0,1,0,50.81V43.17c0-.08.05-.12.14-.12H.68c.08,0,.13,0,.13.12v3.37H5.46V43.17c0-.08,0-.12.14-.12Z"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M12.59,45.23a.13.13,0,0,1,.13.14v5.12c0,2-.42,2.58-2.35,2.58A13.36,13.36,0,0,1,8.89,53a.13.13,0,0,1-.13-.15v-.33c0-.08,0-.12.13-.12h1.48c1.3,0,1.58-.33,1.58-1.4v-.08a11.17,11.17,0,0,1-1.51.08c-2,0-2.32-.58-2.32-2.91V45.37c0-.08,0-.14.12-.14h.5a.13.13,0,0,1,.14.14v2.69c0,1.81.17,2.27,1.56,2.27a12.17,12.17,0,0,0,1.51-.1V45.37a.13.13,0,0,1,.14-.14Z"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M16.71,45.86c-1.46,0-1.63.43-1.63,2.21s.17,2.26,1.55,2.26a12.79,12.79,0,0,0,1.54-.11V45.86Zm2.08-2.81a.12.12,0,0,1,.14.13v7.49c0,.11-.05.15-.15.16a11.8,11.8,0,0,1-2.15.17c-1.95,0-2.32-.57-2.32-2.91s.37-2.91,2.4-2.91c.59,0,1.07,0,1.46.06V43.18c0-.08,0-.13.12-.13Z"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M23.3,45.27c.08,0,.13.07.13.15v.31a.12.12,0,0,1-.14.13h-.92c-.62,0-.93.09-.93.6v4.35c0,.1,0,.14-.14.14h-.49a.12.12,0,0,1-.14-.14V46.3c0-1.11,1.07-1.12,1.53-1.12a6.2,6.2,0,0,1,1.1.09"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M25.15,48.09c0,1.78.21,2.24,1.58,2.24s1.6-.46,1.6-2.24-.21-2.23-1.6-2.23-1.58.44-1.58,2.23m3.94,0c0,2.33-.4,2.91-2.36,2.91s-2.34-.58-2.34-2.91.4-2.91,2.34-2.91,2.36.58,2.36,2.91"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M34.4,45.25a.14.14,0,0,1,.12.14v.33a.13.13,0,0,1-.14.14H32.83c-1.37,0-1.58.44-1.58,2.23s.21,2.24,1.58,2.24h1.55c.09,0,.14,0,.14.13v.33a.13.13,0,0,1-.12.14c-.5,0-1.17.07-1.57.07-1.94,0-2.34-.58-2.34-2.91s.4-2.91,2.34-2.91a14.81,14.81,0,0,1,1.57.07"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M36.52,43.05a.12.12,0,0,1,.13.13v2c.54,0,1.14,0,1.51,0,1.74,0,2.34.22,2.34,2.41v3.22c0,.1,0,.14-.13.14h-.5c-.1,0-.14,0-.14-.14V47.59c0-1.64-.4-1.74-1.45-1.74H36.65v5c0,.1,0,.14-.13.14H36c-.09,0-.13,0-.13-.14V43.18a.12.12,0,0,1,.13-.13Z"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M42.87,43.05c.08,0,.14,0,.14.12v7.64a.13.13,0,0,1-.14.14h-.5c-.08,0-.13,0-.13-.14V43.17c0-.08,0-.12.13-.12Z"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M45.35,48.09c0,1.78.22,2.24,1.59,2.24s1.59-.46,1.59-2.24-.21-2.23-1.59-2.23-1.59.44-1.59,2.23m3.95,0c0,2.33-.41,2.91-2.36,2.91s-2.35-.58-2.35-2.91.4-2.91,2.35-2.91,2.36.58,2.36,2.91"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M53.49,45.27c.08,0,.13.07.13.15v.31a.12.12,0,0,1-.14.13h-.92c-.62,0-.93.09-.93.6v4.35c0,.1,0,.14-.14.14H51a.12.12,0,0,1-.14-.14V46.3c0-1.11,1.07-1.12,1.53-1.12a6.2,6.2,0,0,1,1.1.09"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M55.34,48.09c0,1.78.21,2.24,1.58,2.24s1.6-.46,1.6-2.24-.21-2.23-1.6-2.23-1.58.44-1.58,2.23m3.94,0c0,2.33-.4,2.91-2.36,2.91s-2.34-.58-2.34-2.91.4-2.91,2.34-2.91,2.36.58,2.36,2.91"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M61.7,43.64c.11,0,.16,0,.16.11v1.48H63a.13.13,0,0,1,.14.14v.37c0,.09-.05.13-.14.13H61.86v3.86c0,.48.13.6.69.6h.56c.1,0,.14,0,.14.12v.36a.13.13,0,0,1-.12.14,3.54,3.54,0,0,1-.57,0c-.73,0-1.47,0-1.47-1.11v-4H60.5c-.1,0-.14,0-.14-.13v-.37a.13.13,0,0,1,.14-.14h.59V43.89a.14.14,0,0,1,.11-.14Z"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M65.07,43.05a.12.12,0,0,1,.13.13v2c.54,0,1.14,0,1.51,0,1.74,0,2.35.22,2.35,2.41v3.22a.13.13,0,0,1-.14.14h-.5a.12.12,0,0,1-.14-.14V47.59c0-1.64-.4-1.74-1.44-1.74H65.2v5c0,.1,0,.14-.13.14h-.5c-.09,0-.13,0-.13-.14V43.18a.12.12,0,0,1,.13-.13Z"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M71.42,45.23a.13.13,0,0,1,.14.14v5.44a.12.12,0,0,1-.14.14h-.49c-.1,0-.14,0-.14-.14V45.37a.13.13,0,0,1,.14-.14Zm.25-1.61a.45.45,0,0,1-.49.5.46.46,0,0,1-.51-.5.45.45,0,0,1,.51-.49.44.44,0,0,1,.49.49"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M74.72,48.43c-.69,0-1,.24-1,.9s.34,1,1.34,1a7.12,7.12,0,0,0,1.51-.14V48.43Zm2.61-1.61v3.7a.24.24,0,0,1-.19.27,8.83,8.83,0,0,1-2.25.21C73.5,51,73,50.65,73,49.33c0-1.16.6-1.56,1.77-1.56h1.85v-.84c0-.79-.53-1.07-1.57-1.07H73.58c-.11,0-.14,0-.14-.14v-.3c0-.1,0-.12.13-.14a8.94,8.94,0,0,1,1.43-.1c1.46,0,2.33.41,2.33,1.64"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M83,45.23c.11,0,.15.06.15.14v.15a.35.35,0,0,1-.06.18l-3.36,4.57h3.37a.13.13,0,0,1,.14.14v.4a.13.13,0,0,1-.14.14H78.77c-.1,0-.15,0-.15-.14v-.2a.27.27,0,0,1,.07-.17L82,45.92H78.9a.13.13,0,0,1-.14-.14v-.41a.13.13,0,0,1,.14-.14Z"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M85.21,45.23a.13.13,0,0,1,.14.14v5.44a.12.12,0,0,1-.14.14h-.49c-.1,0-.14,0-.14-.14V45.37a.13.13,0,0,1,.14-.14Zm.25-1.61a.45.45,0,0,1-.49.5.46.46,0,0,1-.51-.5.45.45,0,0,1,.51-.49.44.44,0,0,1,.49.49"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M89.33,45.86c-1.45,0-1.62.43-1.62,2.21s.17,2.26,1.55,2.26a12.64,12.64,0,0,0,1.53-.11V45.86Zm2.09-2.81a.12.12,0,0,1,.13.13v7.49c0,.11,0,.15-.15.16a11.7,11.7,0,0,1-2.14.17c-2,0-2.33-.57-2.33-2.91s.37-2.91,2.4-2.91a14.35,14.35,0,0,1,1.46.06V43.18a.12.12,0,0,1,.13-.13Z"
}), React.createElement("path", {
  className: "esidrex-cls-12",
  d: "M93.9,47.78h3c0-1.56-.26-1.92-1.48-1.92s-1.51.38-1.53,1.92m3.78.12v.3c0,.18,0,.27-.33.27H93.9c0,1.46.29,1.86,1.53,1.86h1.66a.12.12,0,0,1,.14.13v.33a.14.14,0,0,1-.13.14c-.5,0-1.13.07-1.67.07-1.91,0-2.3-.58-2.3-2.91s.39-2.91,2.3-2.91,2.23.54,2.25,2.72"
})));

var SvgEsidrex = function SvgEsidrex(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 312.71 53.07",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEsidrex, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/esidrex.51f706c4.svg";
export { ForwardRef as ReactComponent };